import { APIClient } from "@surya-digital/tedwig";
import { IAnyStateTreeNode, getRoot } from "mobx-state-tree";
import { RootStore } from "../store/RootStore";

// This helper function takes in a store (which can be a node in the MobX State Tree) and returns the shared instance of APIClient.
export const getAPIClient = (store: IAnyStateTreeNode): APIClient => {
  const rootStore = getRoot<typeof RootStore>(store);
  return rootStore.networkingStore.useAPIClient();
};
